import { Alert, FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { useGetActiveManufacturersQuery } from '../../manufacturer/manufacturers-api-slice';

interface ManufacturerFilterProps {
  isAdmin: boolean;
  selectedManufacturerId: number | undefined;
  onManufacturerChange: (manufacturerId: number | undefined) => void;
}

/**
 * Manufacturer dropdown filter for reports.
 * Only visible to administrators; other roles see their assigned manufacturer automatically.
 */
export function ManufacturerFilter({
  isAdmin,
  selectedManufacturerId,
  onManufacturerChange,
}: ManufacturerFilterProps) {
  const {
    data: manufacturers = [],
    isLoading: isLoadingManufacturers,
    error,
  } = useGetActiveManufacturersQuery(undefined, {
    skip: !isAdmin,
  });

  if (!isAdmin) {
    return null;
  }

  if (error) {
    return <Alert severity="error">Unable to load manufacturer list. Please try again.</Alert>;
  }

  return (
    <FormControl sx={{ minWidth: 200 }} size="small">
      <InputLabel id="manufacturer-select-label">Manufacturer</InputLabel>
      <Select
        labelId="manufacturer-select-label"
        id="manufacturer-select"
        value={selectedManufacturerId ?? ''}
        label="Manufacturer"
        onChange={e => {
          const value = e.target.value;
          onManufacturerChange(value === '' ? undefined : Number(value));
        }}
        disabled={isLoadingManufacturers}
      >
        {manufacturers.map(mfg => (
          <MenuItem key={mfg.id} value={mfg.id}>
            {mfg.licenseeName}
          </MenuItem>
        ))}
      </Select>
      {/* UDOMI-1012: hidden helper reserves the same vertical space as date filters in ReportLayout
          (alignItems="flex-start"). Any new filter in the shared row must include an equivalent spacer. */}
      <FormHelperText sx={{ visibility: 'hidden', m: 0 }}>&nbsp;</FormHelperText>
    </FormControl>
  );
}
